import CableOutlinedIcon from '@mui/icons-material/CableOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

import type { NavigationGroup } from './NavigationItem';

/** A super admin sees every platform screen. */
export const platformNavigation = (): Array<NavigationGroup> => [
  {
    heading: 'nav.platform',
    items: [
      { path: '/platform/tenants', label: 'nav.tenants', icon: StorefrontOutlinedIcon, visible: true },
      { path: '/platform/invoices', label: 'nav.invoices', icon: ReceiptLongOutlinedIcon, visible: true },
      { path: '/platform/integrations', label: 'nav.integrations', icon: CableOutlinedIcon, visible: true },
      { path: '/platform/settings', label: 'nav.settings', icon: SettingsOutlinedIcon, visible: true },
      { path: '/platform/audit', label: 'nav.audit', icon: HistoryOutlinedIcon, visible: true },
    ],
  },
];
